import { mainSiteUrl } from '@/mocks/categories';
import { buyerBenefits } from '@/mocks/faq';

export default function WhyChooseUs() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="lg:w-2/5 flex-shrink-0">
            <span className="inline-block px-4 py-1.5 border border-foreground-200 rounded-full text-foreground-500 text-xs font-medium mb-6 whitespace-nowrap">
              Why Choose Us
            </span>
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20photography%20with%20stylish%20sneakers%20designer%20bag%20denim%20jacket%20and%20gold%20jewelry%20pieces%20arranged%20on%20light%20travertine%20stone%20surface%20soft%20afternoon%20sunlight%20casting%20long%20shadows%20editorial%20luxury%20aesthetic%20warm%20neutral%20color%20palette&width=800&height=1000&seq=why-us-v2&orientation=portrait"
              alt="Why choose AllChinaBuy Spreadsheet - organized product finds"
              title="AllChinaBuy Spreadsheet organized products"
              className="w-full rounded-2xl object-cover"
              style={{ height: '420px' }}
              loading="lazy"
            />
          </div>

          <div className="lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 font-bold leading-tight mb-5">
              Why Choose the<br />AllChinaBuy Spreadsheet
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              Our spreadsheet helps buyers discover trusted products faster. Every category is organized to save time, compare prices and find reliable sellers. From sneakers to clothing and accessories, our allchinabuyspreadsheet database is constantly updated with the best allchinabuy finds.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {buyerBenefits.map((benefit) => (
                <div key={benefit.title} className="flex gap-3">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${benefit.icon} text-primary-600 text-sm`}></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-800 mb-1">{benefit.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{benefit.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-white px-8 py-3.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer"
            >
              AllChinaBuy Sheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}